<style>

</style>
<template>
  <div style="position: absolute;">
    <div class="SectionTable">
      <div style="opacity: 0.3;">
        <TemplateSectionRow emptyRow :key="i" v-for="(i) in 40"/>
      </div>
    </div>
  </div>
</template>


<script>

import TemplateSectionRow from './TemplateSectionResourceTableRow.vue';

export default {
  components: {
    TemplateSectionRow,
  },
  props: {},
  computed: {},
};
</script>
